<template>
  <div class="correct-footer">
    <div class="change-info flex_">
      <div class="flex_">
        <p>
          修改 <span>{{ policyForm.updateNum || 0 }}</span> 人
        </p>
        <p>
          保费变化 <span>{{ policyForm.chgTotalPremium || 0 }}</span> 元
        </p>
      </div>
      <div><a-button type="link" v-if="isMobile" class="mobile-download-btn" @click="download">下载保单</a-button></div>
    </div>
    <div class="footer-btn">
      <a-button v-if="!isMobile" class="download-btn btn_" @click="download">下载保单</a-button>
      <a-button class="submit-btn btn_" @click="submit">提交审核</a-button>
      <a-button class="close-btn btn_" @click="close">{{ isMobile ? '返回' : '关闭' }}</a-button>
    </div>

    <!-- 正在批改提示弹窗 -->
    <a-modal title="温馨提示" v-model="showTips" :closable="false" :maskClosable="false">
      <p>订单正在批改中，可通过批改查询查看记录</p>
      <template slot="footer">
        <a-button type="primary" class="modal-btn" @click="close">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import api from '../api/index';
import commonMethods from '../common/methods';
export default {
  name: 'correctFooter',
  inject: ['isMobile'],
  props: {
    policyForm: {
      type: Object,
      default: () => {}
    },
    showTips: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 提交批改数据
    submit() {
      this.$emit('submit');
    },
    // 下载保单
    download() {
      const params = {
        policyId: this.$route.query.policyId
      };
      api
        .exportPolicy(params)
        .then(res => {
          if (res.data.returnCode == '00') {
            if (res.data.content.EPolicyUrl) {
              this.$message.success('下载成功');
              window.open(res.data.content.EPolicyUrl);
            }
          } else {
            this.$message.error(res.data.returnMsg);
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },
    // 关闭批改页面
    close() {
      commonMethods.closeWindow(this);
    }
  }
};
</script>

<style lang="scss">
.correct-footer {
  padding-bottom: 27px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  .change-info {
    padding-left: 24px;
    font-weight: bold;
    color: #000000;
    line-height: 17px;
    p {
      margin-right: 17px;
      margin-bottom: 0;
      span {
        color: #ff3600;
      }
    }
  }
  .footer-btn {
    text-align: right;
    .btn_ {
      height: 33px;
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      color: #ffffff;
      line-height: 17px;
      border-radius: 3px;
      border: 1px solid #ff3600;
      margin-left: 13px;
      padding: 0 20px;
      &.download-btn {
        background: #ff3600;
      }
      &.submit-btn {
        color: #ff3600;
      }
      &.close-btn {
        color: #afafaf;
        border-color: #afafaf;
      }
    }
  }
}
.mobile_ {
  .correct-footer {
    .change-info {
      padding-left: 21px;
      margin-bottom: 30px;
      &.flex_ {
        align-items: center;
        justify-content: space-between;
      }
      .mobile-download-btn {
        color: #007aff;
        span {
          text-decoration: underline;
        }
      }
    }
    .footer-btn {
      display: flex;
      justify-content: space-around;
      .btn_ {
        width: 145px;
        height: 41px;
        border-radius: 10px;
        border: 1px solid #ff3600;
        font-family: PingFangSC-Medium, PingFang SC;
        &.close-btn {
          color: #ffffff;
          background: #dfdfdf;
          border: 1px solid #dfdfdf;
        }
      }
    }
  }
}
</style>
